import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { EmpresaQueVendeComCartoesService } from '../../core/services/empresa-que-vende-com-cartoes.service'
import { EstabelecimentoService } from '../../estabelecimentos/shared/estabelecimento.service'
import { Empresa } from '../../pkw-data/core/empresa.model'
import { VendasRecebimentosComponent } from '../dashboard-extratos/vendas-recebimentos/vendas-recebimentos.component'
import { ExtratoDeRecebimentosService } from '../extratos-de-recebimentos/shared/extrato-de-recebimentos.service'
import { ExtratoDeVendasService } from '../extratos-de-vendas/shared/extrato-de-vendas.service'
import { DadosIniciaisExtratos } from './dados-iniciais-extratos'

@Injectable()
export class DadosIniciaisExtratosResolver implements Resolve<DadosIniciaisExtratos> {
    constructor(
        private empresaQVCCService: EmpresaQueVendeComCartoesService,
        private estabelecimentoService: EstabelecimentoService,
        private extratoDeVendasService: ExtratoDeVendasService,
        private extratoDeRecebimentosService: ExtratoDeRecebimentosService
    ) {}

    resolve() {
        return Observable.forkJoin(
            this.empresaQVCCService.obterAtivas(),
            this.estabelecimentoService.obterTotalDeCarentes()
        ).concatMap(([todasEmpresasQVCC, totalDeEstabelecimentosCarentes]) => {
            const empresa = todasEmpresasQVCC.length
                ? todasEmpresasQVCC[0].empresa
                : undefined

            return Observable.forkJoin(
                this.obterVendasMesAtual(empresa),
                this.obterRecebimentosMesAtual(empresa)
            ).map(([vendasMesAtual, recebimentosMesAtual]) => {
                return {
                    todasEmpresasQVCC,
                    totalDeEstabelecimentosCarentes,
                    vendasMesAtual,
                    recebimentosMesAtual
                } as DadosIniciaisExtratos
            })
        })
    }

    private obterVendasMesAtual(empresa: Empresa) {
        return this.extratoDeVendasService
            .pesquisar(
                VendasRecebimentosComponent.obterFiltro(
                    VendasRecebimentosComponent.periodos.mesAtual,
                    empresa
                ).toFilter()
            )
            .map(extratos => extratos[0])
    }

    private obterRecebimentosMesAtual(empresa: Empresa) {
        return this.extratoDeRecebimentosService
            .pesquisar(
                VendasRecebimentosComponent.obterFiltro(
                    VendasRecebimentosComponent.periodos.mesAtual,
                    empresa
                ).toFilter()
            )
            .map(extratos => extratos[0])
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/shared/dados-iniciais-extratos.resolver.ts